import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Button, Divider } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { userInfoStore } from "Stores/UserInfoStore";
import { I18N_NS } from "Config/i18n";
import { GenericCard } from "Pages/Project/Components/GenericCard";

export const ErrorPage404 = () => {
  const { t } = useTranslation(I18N_NS.PAGE_404);

  return (
    <div className="dashboard">
      <GenericCard>
        <h1 className="display-3">{t("Sorry something went wrong.")}</h1>
        <p className="lead">
          <FontAwesomeIcon icon={["fal", "exclamation-triangle"]} fixedWidth={true} />
          {t("404 Error: Page not found")}
        </p>
        <Divider />
        <div className="mb-2">
          <h2>{t("What happened?")}</h2>
          <ul>
            <li>{t("A technical error occurred.")}</li>
            <li>{t("The page might have been removed.")}</li>
            <li>{t("The link you clicked may not work anymore.")}</li>
          </ul>
        </div>
        <div className="mb-2">
          <h2>{t("What can you do?")}</h2>
          <ul>
            <li>{t("Check if you typed the correct URL and try again.")}</li>
            <li>
              {t("Go back to the previous")} <a onClick={() => window.history.back()}>{t(" page ")}</a>
              {t("and try again. Should the error reoccur, please try again later.")}
            </li>

            {userInfoStore.isAuthenticated && (
              <li>
                {t("Go to the")}
                <Link to="/dashboard">{t(" Dashboard ")}</Link> {t("and do something else.")}
              </li>
            )}
          </ul>
        </div>
        <Divider />
        <Button type="primary" onClick={() => window.history.back()}>
          {t("Return to previous page")}
        </Button>{" "}
        <Button className="m-r-2">
          {userInfoStore.isAuthenticated ? (
            <Link to="/dashboard">{t("Return to Dashboard")}</Link>
          ) : (
            <Link to="/login">{t("Return to Login")} </Link>
          )}
        </Button>
      </GenericCard>
    </div>
  );
};
